// extracted by mini-css-extract-plugin
export default {"AnnouncementDetailPage__Card":"AnnouncementDetailPage_AnnouncementDetailPage__Card__mCz+0"};